import { render, staticRenderFns } from "./Ventilation.vue?vue&type=template&id=4eb5a1dd&"
import script from "./Ventilation.vue?vue&type=script&lang=js&"
export * from "./Ventilation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports